import { fetchAuthSession } from "aws-amplify/auth"
import { store } from "../store"

export async function checkSessionTokens() {
  let session = await fetchAuthSession()

  // No tokens means there is no signed in user, so there is nothing to check
  if (!session.tokens) {
    return
  }

  // Get the access token expiration UTC time in seconds
  const expireTime = +session.tokens.accessToken.payload.exp

  //  Current UTC time in seconds
  const nowTime = Date.now() / 1000

  // Remaining time in seconds
  const remainingTime = expireTime - nowTime

  // Min valid token time in seconds before we make a refresh
  const threshold = 120

  // Amplify refreshes expired tokens by itself (e.g. after the browser has
  // been asleep). The stored user and cookies are then out of date.
  const storedUser = JSON.parse(localStorage.getItem("loggedInUser"))
  const tokensChanged =
    session.tokens.idToken?.toString() !== storedUser?.authToken

  const needsRefresh = remainingTime < threshold

  if (needsRefresh) {
    // Refresh tokens using current session info
    session = await fetchAuthSession({ forceRefresh: true })
  }

  if (needsRefresh || tokensChanged) {
    // Update the data in the state store, which also updates the cookies
    await store.dispatch("setSessionTokens", session)
  }
}
